'use strict';

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOpenFilterName } from './cfs-search-slice';

import { ListFilter } from './search-filters/list-filter.jsx';
import { RangeFilter } from './search-filters/range-filter.jsx';
import { SortOrder } from './search-filters/sort-order.jsx';

import layout from '../../../ui/layout';

export const FilterContent = () => {
	const dispatch = useDispatch();

	const openFilterName = useSelector((state) => state.cfsSearch.openFilterName);

	useEffect(() => {
		if (openFilterName) {
			layout.disablePageScrolling();
		} else {
			layout.enablePageScrolling();
		}
	}, [openFilterName]);

	const filterData = {
		manufacturer: {
			heading: 'Choose make',
			label: 'All makes',
			items: useSelector((state) => state.cfsSearch.filterState.manufacturerItems),
			popularLabel: 'Popular makes',
			popularValues: [
				'Audi',
				'BMW',
				'Ford',
				'Kia',
				'Land Rover',
				'Mercedes-Benz',
				'Nissan',
				'Toyota',
				'Vauxhall',
				'Volkswagen'
			]
		},
		range: {
			heading: 'Choose model',
			label: 'All models', // Range displays as Model in UI
			items: useSelector((state) => state.cfsSearch.filterState.rangeItems)
		},
		model: {
			heading: 'Choose variant',
			label: 'All variants', // Model displays as Variant in UI
			items: useSelector((state) => state.cfsSearch.filterState.modelItems)
		},
		trim: {
			heading: 'Choose trim',
			label: 'All trims',
			items: useSelector((state) => state.cfsSearch.filterState.trimItems)
		},
		derivative: {
			heading: 'Choose version',
			label: 'All versions', // Derivative displays as Version in UI
			items: useSelector((state) => state.cfsSearch.filterState.derivativeItems)
		},
		carType: {
			heading: 'Choose car type',
			label: 'All car types',
			items: useSelector((state) => state.cfsSearch.filterState.carTypeItems)
		},
		gearbox: {
			heading: 'Choose gearbox type',
			label: 'All gearbox types',
			items: useSelector((state) => state.cfsSearch.filterState.gearboxItems)
		},
		fuelType: {
			heading: 'Choose fuel type',
			label: 'All fuel types',
			items: useSelector((state) => state.cfsSearch.filterState.fuelTypeItems)
		},
		mileage: {
			heading: 'Choose mileage',
			label: 'Mileages',
			items: useSelector((state) => state.cfsSearch.filterState.mileageItems)
		},
		colour: {
			heading: 'Choose colour',
			label: 'All colours',
			items: useSelector((state) => state.cfsSearch.filterState.colourItems)
		},
		numberOfDoors: {
			heading: 'Choose number of doors',
			label: 'Number of doors',
			items: useSelector((state) => state.cfsSearch.filterState.numberOfDoorsItems)
		},
		numberOfSeats: {
			heading: 'Choose number of seats',
			label: 'Number of seats',
			items: useSelector((state) => state.cfsSearch.filterState.numberOfSeatsItems)
		},
		engineSize: {
			heading: 'Choose engine size',
			label: 'Engine size range',
			items: useSelector((state) => state.cfsSearch.filterState.engineSizeItems)
		},
		year: {
			heading: 'Choose year',
			label: 'Year range',
			items: useSelector((state) => state.cfsSearch.filterState.yearItems)
		},
		sortOrder: {
			heading: 'Sort by',
			label: 'Sort by options',
			items: useSelector((state) => state.cfsSearch.filterState.sortOptions)
		}
	};

	if (!openFilterName) {
		return null;
	}

	const openFilterData = filterData[openFilterName];

	if (!openFilterData) {
		return null;
	}

	const onClose = (e) => {
		dispatch(setOpenFilterName(null));
	}

	const onModalClick = (e) => {
		if ($(e.target).is('.search-filter-content')) {
			onClose();
		}

		e.stopPropagation();
	};

	let content;
	switch (openFilterName) {
		case 'manufacturer':
		case 'range':
		case 'model':
		case 'trim':
		case 'derivative':
		case 'carType':
		case 'gearbox':
		case 'fuelType':
		case 'mileage':
		case 'colour':
		case 'numberOfDoors':
		case 'numberOfSeats':
			content = (
				<ListFilter
					filterItems={openFilterData.items}
					filterName={openFilterName}
					heading={openFilterData.heading}
					label={openFilterData.label}
					popularValues={openFilterData.popularValues}
					popularLabel={openFilterData.popularLabel}
				/>
			);
			break;
		case 'engineSize':
		case 'year':
			content = (
				<RangeFilter
					filterItems={openFilterData.items}
					filterName={openFilterName}
					heading={openFilterData.heading}
					label={openFilterData.label}
				/>
			);
			break;
		case 'sortOrder':
			content = (
				<SortOrder sortOptions={openFilterData.items} />
			);
			break;
		default:
			content = null;
	}

	if (!content) {
		return null;
	}

	const className = `search-filter-content search-filter-content--${openFilterName}`;

	return (
		<div className={className} onClick={onModalClick} data-close>
			<div className="search-filter-content__modal">
				<div className="search-filter-content__sticky-top">
					<button className="search-filter-content__close icon-24x24-exit-blue" onClick={onClose} data-close />
					<h2 className="search-filter-content__heading">{openFilterData.heading}</h2>
				</div>

				{content}
			</div>
		</div>
	);
}